import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import { IconTemplate } from '@tabler/icons-react';
import { useTemplateWatcherControls } from 'contexts/TemplateWatcherContext';

const STALE_TOOLTIP = 'האישור מתעכב מעל הממוצע';
const DEFAULT_TOOLTIP = 'סנכרון מצב תבניות (לחיצה לעדכון מיידי)';

export default function TemplatesPendingBadge() {
  const theme = useTheme();
  const ctx = useTemplateWatcherControls();

  if (!ctx || ctx.pendingCount <= 0) {
    return null;
  }

  const { pendingCount, hasStalePending, manualSync } = ctx;

  const handleClick = () => {
    void manualSync();
  };

  return (
    <Tooltip title={hasStalePending ? STALE_TOOLTIP : DEFAULT_TOOLTIP}>
      <IconButton
        size="small"
        color="inherit"
        onClick={handleClick}
        aria-label={`תבניות ממתינות לאישור: ${pendingCount}`}
        sx={{
          p: 0.5,
        }}
      >
        <Badge
          badgeContent={pendingCount}
          color={hasStalePending ? 'warning' : 'primary'}
          overlap="circular"
          sx={{
            '& .MuiBadge-badge': {
              fontSize: 10,
              minWidth: 18,
              height: 18,
              ...(hasStalePending && {
                bgcolor: theme.palette.warning.main,
                color: theme.palette.warning.contrastText,
              }),
            },
          }}
        >
          <IconTemplate stroke={1.5} size={22} />
        </Badge>
      </IconButton>
    </Tooltip>
  );
}
